module.exports = __webpack_public_path__ + "img/bbl-logo.f360956f.png";